import { resolveMessage } from './translate';

/** English messages returned by the /auth/* endpoints, mapped to catalog keys. */
const SERVER_MESSAGE_KEYS: Record<string, string> = {
  'Invalid email format': 'auth.server.invalid_email',
  'Password must be at least 8 characters long': 'auth.reset.password_min',
  'User already exists': 'auth.server.user_exists',
  'Failed to send verification email': 'auth.server.send_failed',
  'Failed to create account': 'auth.server.create_failed',
  'Account created successfully. You can now log in.': 'auth.server.created_can_log_in',
  'Account created successfully. Please check your email for verification.': 'auth.server.created_check_email',
  'User not found': 'auth.server.user_not_found',
  'Email already verified': 'auth.server.already_verified',
  'Email is already verified': 'auth.server.already_verified',
  'Invalid verification code': 'auth.server.invalid_code',
  'Verification code expired': 'auth.server.code_expired',
  'Failed to verify email': 'auth.server.verify_failed',
  'Email verified successfully': 'auth.server.verified',
  'Invalid credentials': 'auth.server.invalid_credentials',
  'Account is not active': 'auth.server.inactive',
  'Email not verified. Please check your email for verification.': 'auth.server.not_verified',
  'Login failed': 'auth.server.login_failed',
  'Login successful': 'auth.server.login_ok',
  'If an account with this email exists, a password reset code has been sent.': 'auth.server.reset_sent',
  'Failed to process password reset request': 'auth.server.reset_request_failed',
  'Invalid reset code': 'auth.server.invalid_reset_code',
  'Reset code expired': 'auth.server.reset_code_expired',
  'Password reset successfully': 'auth.server.reset_ok',
  'Failed to reset password': 'auth.reset.failed',
  'If an account exists with this email, a confirmation code has been sent': 'auth.server.resend_sent',
  'Confirmation code resent successfully': 'auth.server.resend_ok',
  'Failed to resend confirmation code': 'auth.server.resend_failed',
};

/** Show a server message in the active language when it's a known one; otherwise as-is. */
export function localizeAuthMessage(message: string | undefined, fallbackKey: string): string {
  if (!message) return resolveMessage(fallbackKey);
  const key = SERVER_MESSAGE_KEYS[message.trim()];
  return key ? resolveMessage(key) : message;
}
